// JavaScript 封装组件

class ScrollPanel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 判断是否是移动端（你可以根据需要改用 userAgent）
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // 移动端不执行
      return;
    }

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const module = this.querySelector(".air4kv-module");
    const panels = module?.querySelectorAll(".air4kv-cnt-item");

    if (!module || !panels?.length) {
      console.warn("缺少 .air4kv-module 或 .air4kv-cnt-item");
      return;
    }

    gsap.to(panels, {
      yPercent: -100 * (panels.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: module,
        start: "top top",
        end: () => "+=" + (window.innerHeight * (panels.length - 1)),
        scrub: true
      }
    });
  }
}

window.customElements.define("scroll-panel", ScrollPanel);



class IcePointScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".ice-point-show");

    if (!triggerEl) {
      console.warn("缺少 .ice-point-show 元素");
      return;
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    tl.to(triggerEl.querySelector(".icepoint__slide-inner2"), {
      clipPath: "inset(0% 0 0 0)",
      duration: 2
    });

    tl.to(triggerEl.querySelectorAll(".icepoint__line-wrapper"), {
      opacity: 1,
      duration: 0.1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-line"), {
      scaleX: 1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-line1"), {
      scaleY: 1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-tle-txt"), {
      opacity: 1,
      duration: 1
    });
  }
}

window.customElements.define("ice-point-scroll", IcePointScroll);


class OutLightScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".out-light");
    if (!triggerEl) {
      console.warn("缺少 .out-light 元素");
      return;
    }

    const imagesWrapper = triggerEl.querySelector(".outlight__images-wrapper");
    const contentWrapper = triggerEl.querySelector(".outlight__content-wrapper");

    let t2 = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    if (imagesWrapper) {
      t2.to(imagesWrapper, {
        opacity: 1,
        duration: 1
      });
    }

    if (contentWrapper) {
      t2.to(contentWrapper, {
        opacity: 1,
        duration: 1
      });
    }
  }
}

window.customElements.define("out-light-scroll", OutLightScroll);



class ShrPointScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".shr-point");
    if (!triggerEl) {
      console.warn("缺少 .shr-point 元素");
      return;
    }

    const imagesWrapper = triggerEl.querySelector(".shrpoint__images-wrapper");
    const line = triggerEl.querySelector(".shrpoint-line");
    const contentWrapper = triggerEl.querySelector(".shrpoint__content-wrapper");

    let t3 = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    if (imagesWrapper) {
      t3.to(imagesWrapper, {
        opacity: 1,
        duration: 1
      });
    }

    if (line) {
      t3.to(line, {
        scaleX: 1,
        duration: 1,
        transformOrigin: "right"
      });
    }

    if (contentWrapper) {
      t3.to(contentWrapper, {
        opacity: 1,
        duration: 1
      });
    }
  }
}

window.customElements.define("shr-point-scroll", ShrPointScroll);



class ScrollStepPanel extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.scrollTrigger = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.scrollTrigger) this.scrollTrigger.kill();
    if (this.observer) this.observer.disconnect();
  }

  init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const stepWrap = this.querySelector('.step_cart_wrrap');
    const stepBox = this.querySelector('.step_cart_box');
    const stepLists = [...this.querySelectorAll('.step_cart_list')];
    const eyebrow = this.querySelector('.p-eyebrow');
    const stepNum = this.querySelector('.step_num');

    const itemLength = stepLists.length;
    if (!stepWrap || !stepBox || !eyebrow || !stepNum || itemLength === 0) return;

    const updateHeight = () => {
      const listHeight = stepLists[0].clientHeight;
      stepBox.style.height = `${listHeight * itemLength}px`;
      // stepWrap.style.height = `${listHeight}px`;
      // stepWrap.style.setProperty('--device-height', `${listHeight}px`);
      eyebrow.style.setProperty('--progress', 1 / itemLength);
    };

    // 监听 resize 高度变化
    this.observer = new ResizeObserver(updateHeight);
    stepLists.forEach((el) => this.observer.observe(el));
    updateHeight();

    this.scrollTrigger = ScrollTrigger.create({
      trigger: stepBox,
      start: 'top top',
      end: 'bottom bottom',
      scrub: false,
      onUpdate: (self) => {
        const progress = self.progress;
        const index = Math.min(
          Math.floor(progress / (1 / itemLength)),
          itemLength - 1
        );

        eyebrow.style.setProperty('--progress', ((index + 1) / itemLength));
        stepNum.innerText = String(index + 1).padStart(2, '0');

        stepLists.forEach((el, i) =>
          el.classList.toggle('active', i === index)
        );
      },
    });
  }
}

window.customElements.define('scroll-step-panel', ScrollStepPanel);


